import styled from "styled-components/native";

import { pickStyle as _, pickThemeKey as theme } from "utils";
import {
  ContainerWidth,
  ContainerHeight,
  ContainerMarginBottom,
} from "./variables";

export const AssigneeContainer = styled.View`
  margin: 0 auto ${_(ContainerMarginBottom) || 50}px;
  position: relative;
  width: ${_(ContainerWidth) || "100%"};
  z-index: 1;
  min-height: ${({ isOpen }) => (isOpen ? _(ContainerHeight) : 0)};
  text-align: center;
  background-color: ${theme("responsible_user_list_background")};
`;
